const FEATURES = {
  ACO: 'ACO',
  AdditionalVisit: 'Additional visit',
  Careteams: 'Careteams',
  ChronicCareMngt: 'Care Harmony',
  CloneModifiers: 'Clone Modifiers',
  DesktopAI: 'Desktop AI',
  Dragon: 'Dragon',
  Hospice: 'Hospice',
  InsuranceMapper: 'Insurance Mapper',
  MedrinaInvoicePCPs: 'Medrina Invoice PCPs',
  NeuroSuite: 'NeuroSuite',
  ONCDemographics: 'ONC Demographics',
  PrincipalCareMngt: 'PrincipalCareManagement',
  PlaceOfServiceOverride: 'Place of service override',
  POS32: 'POS 32 Backend Mapping',
  ProviderHold: 'Provider Hold',
  Scriptsure: 'Scriptsure',
  SuppressCPTSelection: 'Suppress CPT Selection',
  MIPS: 'MIPS',
  VisitNotesPOC: 'VisitNotes POC',
}

export default FEATURES
